import { keysToCamelCase, type SnakeToCamelCaseNested } from "@jti/fe-common";
import type { MagentoApiGetStoreConfigQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export type StoreConfig = SnakeToCamelCaseNested<MagentoApiGetStoreConfigQueryResponse["storeConfig"]>;

export const getStoreConfigEndpoint = (builder: MagentoApiBuilder) => ({
  getStoreConfig: builder.query<StoreConfig, void>({
    query: () => ({
      httpMethod: "GET",
      method: "getStoreConfig",
      params: [],
    }),
    providesTags: [TAGS.STORE_CONFIG],
    transformResponse: (baseQueryReturnValue: MagentoApiGetStoreConfigQueryResponse) =>
      keysToCamelCase(baseQueryReturnValue.storeConfig),
  }),
});
